import { useEffect, useState } from 'react';
import { getOrders } from '../../lib/use-cases/get-orders';

function useOrders() {
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getData = async () => {
        const list = await getOrders();

        setOrders(list);
        setIsLoading(false);
    };

    useEffect(() => {
        getData();
    }, []);

    return {
        orders,
        isLoading
    };
}

export {
    useOrders
};
